var _ = require('optimizely-client-fn');

var createError = require('core/utils/custom_error').create;
var JSONP = require('core/plugins/sources/jsonp');
var Logger = require('core/utils/logger');
var PromiseEnv = require('core/lib/promise');
var Poll = require('core/utils/poll');
var WindowEnv = require('core/env/window');

var VENDOR = 'lotame';
var LOTAME_HELP_AUDIENCESTORAGE = 'https://my.lotame.com/t/g9hxvnw/lt-js-detailed-reference-guide#audiencelocalstorage-parameter';

var LotameError = createError('LotameError');

var useLightingTag = __LOTAME_USE_LIGHTNING_TAG__;
var fallbackToLegacy = __LOTAME_FALLBACK__;

function getAudienceFunction(lotameObject) {
  if(lotameObject.hasOwnProperty('getAudiences')){
    return lotameObject.getAudiences;
  }
}

function get_audience_from_lighting_tag_api(clientId) {
  // Poll to get the object
  return Poll.pollFor(_.partial(WindowEnv.getGlobal, `lotame_${clientId}`), 50, 20).then(function(lotameObject){
    if (!lotameObject){
      throw new LotameError('Lotame object not found in browser');
    }

    if(lotameObject.config && !lotameObject.config.audienceLocalStorage) {
      throw new LotameError('Lotame config needs to include audienceLocalStorage param ' + LOTAME_HELP_AUDIENCESTORAGE);
    }

    // Wait until lotame object initialization
    return Poll.pollFor(_.partial(getAudienceFunction, lotameObject), 50, 20).then(getAudiencesFn => {
      // call the api
      return {
        'audiences': getAudiencesFn()
      };
    });
  });
}


function get_audience_from_audience_extraction_api(clientId): Promise<Object> {
  // This is based on audience extraction api https://my.lotame.com/t/x2hx20x/audience-extraction-api
  var audienceExtractionUrl = __LOTAME_AUDIENCE_EXTRACTION_URL__ + '/c=' + clientId + '/pe=y/callback=%cb%';

  return JSONP.fetchData('lotame', audienceExtractionUrl, 'optimizely_lotame')
    .then(function (data) {
      var firstPartyAudiences = data.Profile.Audiences.Audience || [];
      var thirdPartyAudiences = data.Profile.Audiences.ThirdPartyAudience || [];
      var audiences = [].concat(firstPartyAudiences, thirdPartyAudiences);

      return {
        audiences: _.map(audiences, function (audience) {
          return audience.id;
        }),
      };
    });
}

var pluginAudienceLotame:AudiencePluginConfig = {
  provider: {
    isAsync: true,
    isLazy: false,
    // Caching policy: Any cached data is always usable, but also always enqueue an async
    // refresh of Lotame audience memberships ASAP.
    isSticky: false,

    getter: [
      'stores/integration_settings',
      /**
       * @returns {Object}
       *        An object with entries like ('foo', true), indicating the visitor is a
       *        member of the Lotame audience with targeting ID (AKA abbrevation) 'foo'.
       */
      function(IntegrationSettingsStore) {
        var clientId;
        try {
          clientId = IntegrationSettingsStore.get(VENDOR).client_id;
        } catch (e) {
          return PromiseEnv.reject(new Error('Lotame client_id missing from integration settings'));
        }

        if (useLightingTag) {
          return get_audience_from_lighting_tag_api(clientId)
            .catch( error => {
              if (fallbackToLegacy) {
                Logger.warn('Lotame Lighting Tag failed with error "' + error + '", falling back to audience extraction.');
                return get_audience_from_audience_extraction_api(clientId);
              }
              throw error;
            });
        } else {
          return get_audience_from_audience_extraction_api(clientId);
        }
      },
    ],
  },

  matcher: require('core/plugins/matchers/key_value'),
  vendor: VENDOR,
};

module.exports = function (PluginManager) {
  PluginManager.registerAudiencePlugin(pluginAudienceLotame);
};

if (__TEST__) {
  module.exports.plugin = pluginAudienceLotame;

  module.exports.setLightingTag = function(test) {
    useLightingTag = test;
  };

  module.exports.getLightingTag = function() {
    return useLightingTag;
  };

  module.exports.setFallback = function(test) {
    fallbackToLegacy = test;
  };

  module.exports.getFallback = function() {
    return fallbackToLegacy;
  };


}

